// https://kaleidoscope.slite.com/app/docs/Y8hEkAxzZu3SCo
export enum ErrorCode {
  E9000 = "E9000", // Engine fail or initialise of model
  E9001 = "E9001", // missing meta tag for org_id in Auth0 user
  E9002 = "E9002", // No user data from auth0
  E9003 = "E9003", // missing meta tag role_id in Auth0 user
  E9004 = "E9004", // missing meta tag analytics_id in Auth0 user
}

export class ApplicationError extends Error {
  errorCode: ErrorCode
  constructor(errorCode: ErrorCode, message?: string) {
    message = message ? `${errorCode}: ${message}` : `${errorCode}`
    super(message)
    this.errorCode = errorCode
  }
}
